module.exports = __webpack_public_path__ + "img/hero.c55f3564.png";